<script setup>
import BarChart from './BarChart.vue';
import {computed} from "vue";

const props = defineProps({
  chartLabels: Array,
  dataValues: Array,
  axisLabel: String
})
const chartHeight = computed(() => (props.dataValues.length * 30) + 60)
const canvasStyles = computed(() => {
  return {
    height: `${chartHeight}px`,
    'margin-bottom': '1em'
  }
})
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-sm-12">
      <BarChart v-bind:chartLabels="props.chartLabels" v-bind:dataValues="props.dataValues"
                v-bind:axisLabel="props.axisLabel" :height="chartHeight" :styles="canvasStyles">
      </BarChart>
    </div>
  </div>
</template>
